"use strict";

window.FoG = window.FoG || {};

window.FoG.Sections = (function($) {
  var copySrcIdx = 0;
  
  function openPermalink() {
    // Nothing here right now.
  }
  
  function renderThumbAndSocials($item, item) {
    if (item.thumb) {
      $item.find('.article__thumbContainer').css('background-image', 'url("' + item.thumb + '")');
    }

    $item.find('.article__thumbLinkOverlay').attr('href', item.safePermalink).attr('title', item.safeTitle);
    $item.find('.shareMenu__shareOptionList fa-twitter').attr('href', item.twitterUrl);
    $item.find('.shareMenu__shareOptionList fa-linkedin').attr('href', item.liUrl);
    $item.find('.shareMenu__shareOptionList fa-facebook-square').attr('href', item.fbUrl);
    $item.find('.shareMenu__shareOptionList fa-envelope').attr('href', item.mailUrl);
    $item.find('.simplefavorite-button').attr('data-postid', item.id);
    
    var copyId = 'copy-loadmore-permalink-' + (copySrcIdx++);
    $item.find('.permalinkShareWidget__permalink').attr('id', copyId).text(item.safePermalink);
    $item.find('.permalinkShareWidget__dialogWrapper button').attr('data-clipboard-target', copyId);
    FoG.prepClipboard($('.permalinkShareWidget__dialogWrapper button'));
  }
  
  function renderTerm(term) {
    var $termTemplate = $('.section--termList article.cloneable');
    var $term = $termTemplate.clone().removeClass('cloneable');

    $term.find('.postTitle a').attr('href', term.safePermalink).html(term.safeTitle);
    $term.find('.section--termList__articleCountNumber').text(term.articleCount);
    
    renderThumbAndSocials($term, term);
    
    return $term;
  }
  
  function renderArticle(article) {
    var $articleTemplate = $('.section--articleFullList article.cloneable');
    var $article = $articleTemplate.clone().removeClass('cloneable');

    renderThumbAndSocials($article, article);
    
    if (article.tag) {
      $article.find('.postTag').text(article.tag).attr('href', article.tagPermalink);
    }
    else {
      $article.find('.postTag').remove();
    }
    
    $article.find('.postTitle a').attr('href', article.safePermalink).html(article.safeTitle);
    $article.find('.postAuthor').text(article.author);
    
    $article.find('.postDate').attr('datetime', article['date-iso']).text(article['date-display']);
    
    $article.find('.why-it-matters').text(article.whyitmatters);
    return $article;
  }
  
  function onLoadMore(response) {
    var lmDef = FoG.loadMoreDef;
    lmDef.loadingMore = false;

    var $itemListParent = (lmDef.isTermList ? $('.section--termList') : $('.section--articleFullList'));
    var $itemList = $itemListParent.find('.section--articleList__container');
    var fnRender = (lmDef.isTermList ? renderTerm : renderArticle);
    
    // Loop through articles and create/populate/append the container element
    $.each(response.articles, function(dummyIdx, article) { 
      $itemList.append(fnRender(article));
    });
    
    lmDef.hasMore = response.hasMore;
    lmDef.nextOffset = response.nextOffset;

    if (!lmDef.hasMore) {
      $itemListParent.find('.loadMore').remove();
    }
  }
  
  function loadMore() {
    var lmDef = FoG.loadMoreDef;
    var $lmBtn = $('.section--articleFullList').find('.loadMore');
    
    
    if (!lmDef || !lmDef.hasMore) { 
      $lmBtn.remove(); 
      return;
    }
    
    if (lmDef.loadingMore) { return; }
    
    lmDef.loadingMore = true;
    
    var params = {
      tax: lmDef.tax,
      termId: lmDef.termId,
      offset: lmDef.nextOffset,
      excludedIds: lmDef.exclude,
      search: lmDef.search
    }
    
    var fnResetLoadingMore = function() { lmDef.loadingMore = false; }
    var action = lmDef.isTermList ? 'term-loadMore' : 'post-loadMore';
    
    NA.Ajax.get(action, params, onLoadMore, fnResetLoadingMore);
  }
  
  function init() {
    $('.section--articleFullList, .section--termList').find('.loadMore').on('click', loadMore);
  }
  
  $(init);
  
  return {
    openPermalink: openPermalink
  };
})(jQuery);